import React, { useEffect, useState } from 'react';
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import moment from "moment";
import { Container, Col, Form, Row, Image, Button } from "react-bootstrap";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
    TextField,
    FormControl,
    Select,
    InputLabel,
    makeStyles,
    MenuItem,
} from "@material-ui/core";
import { ReusableOnboardingMapButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Media from "react-media";
import Switch from "react-switch";
import { getCountries, getCountryCallingCode } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { errorAlert } from '../../../../../function/alert';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ExperienceData from '../../CreateExperiences/ExperienceData';
import GuestData from './GuestData';


const GuestForm = ({ formik, experience, paymentPage, onCancel, reservationSlots, btnDisabled, count, edit }) => {
    const history = useHistory();
    let type = history?.location?.pathname?.includes('edit') ? "EDIT" : "ADD";

    const allSeatingArea = useSelector(
        (state) => {
            return !isEmpty(state.onboarding?.onboard_subscription_details?.casual_dining_status?.seating?.general_seating?.seating_areas) ? state.onboarding.onboard_subscription_details?.casual_dining_status?.seating?.general_seating?.seating_areas : [];
        });

    const seatingArea = useSelector(
        (state) => {
            return state.category?.seating_area?.filter(ele => allSeatingArea.includes(ele._id));
        });

    let seatsCheck = formik.values.kidsCount + formik?.values?.adultCount;
    if (formik?.values?.package?.count) {
        seatsCheck = seatsCheck + formik?.values?.package?.count;
    }

    const onDescPackage = (pack) => {
        if (pack.name === formik.values.package.name) {
            let newPack = {
                name: pack.name,
                count: formik.values.package.count,
                price: pack.discountedPrice || pack.price,
                adults: pack.adults,
                kids: pack.kids,
                addMore: formik.values.package.addMore
            }
            if (formik.values.package.count > 0) {
                newPack.count = newPack.count - 1;
                newPack.adults = pack.adults * newPack.count;
                newPack.kids = pack.kids * newPack.count;
                if (newPack.count === 0) {
                    newPack.name = "";
                    newPack.addMore = false;
                    formik.setValues({ ...formik.values, 'package': newPack, adultCount: 0, adultPrice: experience.adultPrice, kidsCount: 0, kidsPrice: experience.kidsPrice });
                } else {
                    formik.setFieldValue('package', newPack);
                }
            } else {
                newPack.count = 0;
                newPack.name = "";
                newPack.adults = pack.adults * newPack.count;
                newPack.kids = pack.kids * newPack.count;
                newPack.addMore = false;
                formik.setValues({ ...formik.values, 'package': newPack, adultCount: 0, adultPrice: experience.adultPrice, kidsCount: 0, kidsPrice: experience.kidsPrice });
            }
        }
    }

    const onIncPackage = (pack) => {
        let newPack = {
            name: pack.name,
            count: 0,
            price: pack.discountedPrice || pack.price,
            adults: pack.adults,
            kids: pack.kids,
            addMore: formik.values.package.addMore
        };
        if (pack.name === formik.values.package.name) {
            newPack.count = formik.values.package.count + 1;
        } else {
            newPack.count = 1;
            newPack.addMore = false;
            formik.setValues({ ...formik.values, adultCount: 0, adultPrice: experience.adultPrice, kidsCount: 0, kidsPrice: experience.kidsPrice })
        }
        if ((experience?.expType === "CURATED" && ((experience.allowSingleBooking && seatsCheck < experience?.maxSeats) || !experience.allowSingleBooking) && seatsCheck < experience?.seatsLeft) || experience?.expType === "SPECIAL") {
            newPack.adults = pack.adults * newPack.count;
            newPack.kids = pack.kids * newPack.count;
            formik.setFieldValue('package', newPack);
        } else errorAlert("Reached Maximum limit")
    }

    useEffect(() => {
        if (formik.errors && formik.userDetails?.mobileNumber) {
            let numberElement = document.getElementById("mobileNumber");
            numberElement.focus();
        } else if (formik.errors && formik.errors.userDetails?.name) {
            let nameElement = document.getElementById("guestName");
            nameElement.focus();
        }
        // else if (formik.errors && formik.errors.tc) {
        //   let termAndConditionsElement = document.getElementById("tc");
        //   termAndConditionsElement.focus();
        // }
    }, [count]);

    useEffect(() => {
        if (formik.values.reservationDate && formik.values.expType === 'CURATED') {
            let timeSlot = moment(experience.timings[moment(formik.values.reservationDate, 'YYYY-MM-DD').format('DD-MM-YYYY')].multipleHours[0].openingTime).format('hh:mm A');
            formik.setFieldValue('reservationTime', timeSlot);
        }
    }, [formik.values]);

    const validateOpen = (date) => {
        try{
        console.log(experience?.timings[moment(date).format('dddd')], moment(date).format('dddd'))
            if(experience?.expType === "CURATED"){
                return experience?.timings[moment(date).format("DD-MM-YYYY")].open;
            }else {
                return experience?.timings[moment(date).format('dddd')].open;
            }
       
        
        }catch(err){
            console.error(err);
            return false;
        }
    }
    return (
        <>
        <div className='mobile-p-2' style={{overflowX: "hidden"}}>
            <div className="p-2 d-flex justify-content-between">
                <div className="col-12 p-0">
                    <div className='d-flex justify-content-between'>
                        <div className="col-6 align-items-center">
                            <h4 className="mb-4">Add Guest</h4>
                            <div className="f16-500" style={{ fontWeight: "bold" }}>
                                {experience?.name || ""}
                            </div>
                            <div className="f12-400" style={{ color: "#EE3A23" }}>
                                Experience ID: {experience?.expId || ""}
                            </div>
                        </div>
                        <div className="px-3 col-6">
                            <div className="f12-500  py-2">Experience Date & Time</div>
                            <div className="row">
                                <div className="col-6 py-2">
                                    <div className="f10-400 opacity5">Start Date</div>
                                    <div className="f16-700">
                                        {moment(experience?.startDate).format("Do MMM YYYY")}
                                        {/* <br /> */}
                                        {/* {moment(experience?.startDate).format("hh:mm A")} */}
                                    </div>
                                </div>
                                <div className="col-6 py-2">
                                    <div className="f10-400 opacity5">End Date</div>
                                    <div className="f16-700">
                                        {moment(experience?.endDate).format("Do MMM YYYY")}
                                        {/* <br /> */}
                                        {/* {moment(experience?.endDate).format("hh:mm A")} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <hr />
            <Form className="py-4 px-2">
                <Row>
                    <Col md={12} lg={10} xl={8}>
                        <Row>
                            <Col md={6}>
                                <Row className='mr-0'>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <Form.Group
                                            // className="reusableInputComponent-main mb-0"
                                            controlId={"code"}
                                        >
                                            <div className="input-phone-country-code-reusable w-100">
                                                <select
                                                    id="code"
                                                    name="userDetails.countryCode"
                                                    value={formik.values.userDetails.countryCode}
                                                    onChange={formik.handleChange}
                                                    className="w-100"
                                                >
                                                    <option value={formik.values.userDetails.countryCode}>
                                                        {formik.values.userDetails.countryCode}
                                                    </option>
                                                    {getCountries().map((country) => (
                                                        <option
                                                            key={country}
                                                            value={
                                                                "+" + getCountryCallingCode(country)
                                                            }
                                                        >
                                                            {en[country]} (+
                                                            {getCountryCallingCode(country)})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={9} md={8} className='pr-0'>
                                        <Form.Group>
                                            <TextField
                                                id="mobileNumber"
                                                label="Phone Number"
                                                type="number"
                                                variant="outlined"
                                                className={`w-100 ${formik.errors?.userDetails?.mobileNumber &&
                                                    formik.touched?.userDetails?.mobileNumber
                                                    ? "enError"
                                                    : ""
                                                    }`}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value))
                                                        .toString()
                                                        .slice(0, 10);
                                                }}
                                                disabled={edit}
                                                name="userDetails.mobileNumber"
                                                onChange={formik.handleChange}
                                                value={
                                                    formik.values.userDetails.mobileNumber ||
                                                    formik.initialValues.userDetails.mobileNumber
                                                }
                                                onBlur={(formik.handleBlur)}
                                            />
                                            {formik.errors?.userDetails?.mobileNumber &&
                                                formik.touched?.userDetails?.mobileNumber ? (
                                                <div className="pho_14_regular text-danger">
                                                    {formik.errors?.userDetails?.mobileNumber}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={5}>
                                <Form.Group>
                                    <TextField
                                        id="guestName"
                                        label="Name"
                                        type="text"
                                        variant="outlined"
                                        className={`w-100 ${formik.errors?.userDetails?.name &&
                                            formik.touched?.userDetails?.name
                                            ? "enError"
                                            : ""
                                            }`}
                                        inputProps={{
                                            maxLength: 64,
                                        }}
                                        disabled={edit}
                                        name="userDetails.name"
                                        onChange={formik.handleChange}
                                        value={
                                            formik.values?.userDetails?.name ||
                                            formik.initialValues?.userDetails?.name
                                        }
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.errors?.userDetails?.name &&
                                        formik.touched?.userDetails?.name ? (
                                        <div className="pho_14_regular text-danger">
                                            {formik.errors?.userDetails?.name}
                                        </div>
                                    ) : null}
                                </Form.Group>
                            </Col>
                            <Col md={5}>
                                <Form.Group>
                                    <TextField
                                        id="guestEmail"
                                        label="Email"
                                        type="email"
                                        variant="outlined"
                                        className={`w-100 ${formik.errors?.userDetails?.name &&
                                            formik.touched?.userDetails?.name
                                            ? "enError"
                                            : ""
                                            }`}
                                        inputProps={{
                                            maxLength: 64,
                                        }}
                                        disabled={edit}
                                        name="userDetails.email"
                                        onChange={formik.handleChange}
                                        value={
                                            formik.values?.userDetails?.email ||
                                            formik.initialValues?.userDetails?.email
                                        }
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.errors?.userDetails?.email &&
                                        formik.touched?.userDetails?.email ? (
                                        <div className="pho_14_regular text-danger">
                                            {formik.errors?.userDetails?.email}
                                        </div>
                                    ) : null}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>

                    {experience?.allowSingleBooking ?
                        <Col md={12} lg={8}>
                            <div className="f16-500 mt-3">Select Tickets</div>
                            <div className="f11-500 opacity5 pb-4 pt-2">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>  The Kids ranging below 6 years will be kept under kids category
                            </div>
                            <div className="d-flex enPartySize">
                                <div>
                                    <div className="d-flex pr-3">
                                        <div className="enKidsIcon mr-2">
                                            <Image
                                                src={require("../../../../../assets/images/ActionImages/parents.png")}
                                                alt="View"
                                                title="View"
                                                width="6px"
                                            />
                                        </div>
                                        <div className="pl-md-2 enPartyPersonEdit">
                                            <div className="f14-500 pb-2">Adult</div>
                                            <div className="d-flex align-items-center">
                                                <Button
                                                    variant="link"
                                                    className="p-0"
                                                     disabled={edit}
                                                    onClick={() => {
                                                        formik.setFieldValue('adultCount', formik.values.adultCount > 0 ? formik.values.adultCount - 1 : 0)
                                                    }}

                                                >
                                                    <Image
                                                        src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                        alt="Remove"
                                                        title="Remove"
                                                        fluid
                                                    />
                                                </Button>
                                                <input
                                                    placeholder="00"
                                                    className="enInputValueOnly f12-700"
                                                    value={formik.values.package.count > 0 ? 0 : formik.values.adultCount}
                                                    name="adult"
                                                    id="adult"
                                                />
                                                <Button
                                                    variant="link"
                                                    className="p-0"
                                                     disabled={edit}
                                                    onClick={() => {
                                                        if ((experience?.expType === "CURATED" && seatsCheck < experience?.maxSeats && seatsCheck < experience?.seatsLeft) || experience?.expType === "SPECIAL") {
                                                            if (formik.values.package.count) {
                                                                formik.setFieldValue('package', GuestData.initialValues.package);
                                                            }
                                                            formik.setFieldValue('adultCount', formik.values.adultCount + 1)
                                                        } else errorAlert("Reached Maximum limit")
                                                    }}
                                                >
                                                    <Image
                                                        src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                        alt="Add"
                                                        title="Add"
                                                        fluid
                                                    />
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center mt-3" style={{ paddingLeft: "6rem" }}>
                                        <i
                                            className="fa fa-inr mr-2 pt-1"
                                            style={{ fontSize: "15px" }}
                                            aria-hidden="true"
                                        ></i>
                                        <p className="f14-500">{experience?.adultPrice}</p>
                                        <p className="f10-400 text-gray ml-1">/per person</p>
                                        <Button
                                            variant="link"
                                            className="mr-3"
                                             disabled={edit}
                                            onClick={() => {
                                                formik.setFieldValue('adultPrice', experience?.adultPrice);
                                                formik.setFieldValue('adultPriceChanged', !formik.values?.adultPriceChanged);
                                            }}
                                        >
                                            <Image
                                                src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                                                alt="Edit"
                                                title="Edit"
                                                fluid
                                            />
                                        </Button>
                                        {formik.values?.adultPriceChanged ? (
                                            <div className="d-flex align-items-center mt-3">
                                                <NewInputText
                                                    extraClass="mb-1"
                                                    name="adultPrice"
                                                    maxLength={5}
                                                     disabled={edit}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    inputType="number"
                                                    required={true}
                                                    onKeyDown={InputNumberFunc}
                                                    onFocusOut={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.adultPrice}
                                                    labelText="Enter New Amount"
                                                    controlClass="newAdult"
                                                />
                                            </div>
                                        ) : <></>}
                                    </div>
                                </div>
                                {!experience?.ageRestriction ? <div>
                                    <div className="d-flex pr-3 border-left pl-3">
                                        <div className="enKidsIcon mr-2">
                                            <Image
                                                src={require("../../../../../assets/images/ActionImages/kids.png")}
                                                alt="View"
                                                title="View"
                                                width="6px"
                                            />
                                        </div>
                                        <div className="pl-md-2 enPartyPersonEdit">
                                            <div className="f14-500 pb-2">Kids</div>
                                            <div className="d-flex align-items-center">
                                                <Button
                                                    variant="link"
                                                    className="p-0"
                                                     disabled={edit}
                                                    onClick={() => {

                                                        formik.setFieldValue('kidsCount', formik.values.kidsCount > 0 ? formik.values.kidsCount - 1 : 0)
                                                    }}
                                                >
                                                    <Image
                                                        src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                        alt="Remove"
                                                        title="Remove"
                                                        fluid
                                                    />
                                                </Button>
                                                <input
                                                    placeholder="00"
                                                    className="enInputValueOnly f12-700"
                                                    value={formik.values.package.count > 0 ? 0 : formik.values.kidsCount}
                                                    name="kids"
                                                    id="kids"
                                                />
                                                <Button
                                                    variant="link"
                                                    className="p-0"
                                                     disabled={edit}
                                                    onClick={() => {
                                                        if ((experience?.expType === "CURATED" && formik.values.adultCount + formik.values.kidsCount < experience?.maxSeats && formik.values.adultCount + formik.values.kidsCount < experience?.seatsLeft) || experience?.expType === "SPECIAL") {
                                                            if (formik.values.package.count) {
                                                                formik.setFieldValue('package', GuestData.initialValues.package);
                                                            }
                                                            formik.setFieldValue('kidsCount', formik.values.kidsCount + 1)
                                                        } else errorAlert("Reached Maximum limit")
                                                    }}
                                                >
                                                    <Image
                                                        src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                        alt="Add"
                                                        title="Add"
                                                        fluid
                                                    />
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center mt-3" style={{ paddingLeft: "6rem" }}>
                                        <i
                                            className="fa fa-inr mr-2 pt-1"
                                            style={{ fontSize: "15px" }}
                                            aria-hidden="true"
                                        ></i>
                                        <p className="f14-500">{experience?.kidsPrice}</p>
                                        <p className="f10-400 text-gray ml-1">/per person</p>
                                        <Button
                                            variant="link"
                                            className="mr-3"
                                             disabled={edit}
                                            onClick={() => {
                                                formik.setFieldValue('kidPriceChanged', !formik.values?.kidPriceChanged);
                                            }}
                                        >
                                            <Image
                                                src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                                                alt="Edit"
                                                title="Edit"
                                                fluid
                                            />
                                        </Button>
                                        {formik.values?.kidPriceChanged ? (
                                            <div className="d-flex align-items-center mt-3">
                                                <NewInputText
                                                    extraClass="mb-1"
                                                    name="kidsPrice"
                                                    maxLength={5}
                                                     disabled={edit}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    inputType="number"
                                                    onKeyDown={InputNumberFunc}
                                                    onFocusOut={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.kidsPrice}
                                                    labelText="Enter New Amount"
                                                    controlClass="newAdult"
                                                />
                                            </div>
                                        ) : <></>}
                                    </div>
                                </div> : <></>}
                            </div>
                        </Col>
                        : <></>}
                    <hr />
                    {experience?.packages?.length ? <><Col md={12} lg={8}>
                        <div className="f12-400">Packages</div>
                        <div className="d-flex enPartySize mt-3">
                            {experience?.packages?.filter(e => e.status)?.map(pack => <>
                                <div className="pr-3 pb-3">
                                    <div className="pl-md-2 enPartyPersonEdit">
                                        <div className="f14-700 pb-2">{pack.name}</div>
                                        <div className="f12-400 pb-2">{`No of people allowed per ticket : ${pack?.adults ? `${pack.adults} Adults` : ""} ${pack?.kids ? `,${pack.kids} Kids` : ""}`}</div>
                                        <div className="d-flex align-items-center mt-2">
                                            <Button
                                                variant="link"
                                                className="p-0"
                                                onClick={() => onDescPackage(pack)}
                                                disabled={edit}
                                            >
                                                <Image
                                                    src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                    alt="Remove"
                                                    title="Remove"
                                                    fluid
                                                />
                                            </Button>
                                            <input
                                                placeholder="00"
                                                className="enInputValueOnly f12-700"
                                                value={pack.name === formik.values?.package?.name ? formik.values?.package?.count : 0}
                                                name="package count"
                                                id="package count"
                                            />
                                            <Button
                                                variant="link"
                                                className="p-0"
                                                onClick={() => onIncPackage(pack)}
                                                disabled={edit}
                                            >
                                                <Image
                                                    src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                    alt="Add"
                                                    title="Add"
                                                    fluid
                                                />
                                            </Button>
                                        </div>
                                        {pack.discountedPrice ? <div className="d-flex align-items-center justify-content-start mt-3">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <i
                                                    className="fa fa-inr"
                                                    style={{ fontSize: "15px" }}
                                                    aria-hidden="true"
                                                ></i>
                                                <p className="f14-400 pl-2"><del>{pack.price}</del></p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between ml-4">
                                                <i
                                                    className="fa fa-inr"
                                                    style={{ fontSize: "15px" }}
                                                    aria-hidden="true"
                                                ></i>
                                                <p className="f14-700 pl-2">{pack.discountedPrice}</p>
                                                <p className="f10-400 text-gray pl-2">/per package</p>
                                            </div>
                                        </div>
                                            : <div className="d-flex align-items-center justify-content-start mt-3">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <i
                                                        className="fa fa-inr"
                                                        style={{ fontSize: "15px" }}
                                                        aria-hidden="true"
                                                    ></i>
                                                    <p className="f14-400 pl-2">{pack.price}</p>
                                                    <p className="f10-400 text-gray pl-2">/per package</p>
                                                </div>
                                            </div>}
                                    </div>
                                    {pack.seatCustomized ?
                                        <>
                                            <div className="d-flex flex-wrap align-items-center my-2 pb-4">
                                                <div className="f12-500">
                                                    Add more people to the package ?
                                                </div>
                                                <div className="d-flex align-items-center ml-4">
                                                    <div className="f12-500 mr-2">No</div>
                                                    <Switch
                                                        onChange={() => formik.setFieldValue('package',
                                                            {
                                                                ...formik.values.package,
                                                                addMore: pack.name === formik?.values?.package?.name
                                                                    ? !formik.values.package.addMore : formik.values.package.addMore
                                                            })}
                                                        checked={pack.name === formik?.values?.package?.name ? formik.values.package.addMore : false}
                                                        offColor="#EEEEEE"
                                                        onColor="#EEEEEE"
                                                        offHandleColor="#212121"
                                                        disabled={edit}
                                                        onHandleColor="#59F832"
                                                        handleDiameter={24}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        height={15}
                                                        width={41}
                                                        boxShadow="-2px 0px 5px #0000003B"
                                                        activeBoxShadow="-2px 0px 5px #0000003B"
                                                        id="material-switch"
                                                    />
                                                    <div className="f12-500 ml-2">Yes</div>
                                                </div>
                                            </div>
                                            {(pack.name === formik.values.package.name && formik.values.package.addMore) ?
                                                <div className="d-flex enPartySize">
                                                    <div>
                                                        <div className="d-flex pr-3">
                                                            <div className="enKidsIcon mr-2">
                                                                <Image
                                                                    src={require("../../../../../assets/images/ActionImages/parents.png")}
                                                                    alt="View"
                                                                    title="View"
                                                                    width="6px"
                                                                />
                                                            </div>
                                                            <div className="pl-md-2 enPartyPersonEdit">
                                                                <div className="f14-500 pb-2">Adult</div>
                                                                <div className="d-flex align-items-center">
                                                                    <Button
                                                                        variant="link"
                                                                        className="p-0"
                                                                        disabled={edit}
                                                                        onClick={() => {
                                                                            formik.setFieldValue('adultCount', formik.values.adultCount > 0 ? formik.values.adultCount - 1 : 0)
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                                            alt="Remove"
                                                                            title="Remove"
                                                                            fluid
                                                                        />
                                                                    </Button>
                                                                    <input
                                                                        placeholder="00"
                                                                        className="enInputValueOnly f12-700"
                                                                        value={formik.values.adultCount}
                                                                        name="adult"
                                                                        id="adult"
                                                                    />
                                                                    <Button
                                                                        variant="link"
                                                                        className="p-0"
                                                                        disabled={edit}
                                                                        onClick={() => {
                                                                            if ((experience?.expType === "CURATED" && seatsCheck < experience?.maxSeats && seatsCheck < experience?.seatsLeft) || experience?.expType === "SPECIAL")
                                                                                formik.setFieldValue('adultCount', formik.values.adultCount + 1)
                                                                            else errorAlert("Reached Maximum limit")
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                                            alt="Add"
                                                                            title="Add"
                                                                            fluid
                                                                        />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-3" style={{ paddingLeft: "6rem" }}>
                                                            <i
                                                                className="fa fa-inr mr-2 pt-1"
                                                                style={{ fontSize: "15px" }}
                                                                aria-hidden="true"
                                                            ></i>
                                                            <p className="f14-500">{experience?.adultPrice}</p>
                                                            <p className="f10-400 text-gray ml-1">/per person</p>
                                                            <Button
                                                                variant="link"
                                                                className="mr-3"
                                                                disabled={edit}
                                                                onClick={() => {
                                                                    formik.setFieldValue('adultPriceChanged', !formik.values?.adultPriceChanged);
                                                                }}
                                                            >
                                                                <Image
                                                                    src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                                                                    alt="Edit"
                                                                    title="Edit"
                                                                    fluid
                                                                />
                                                            </Button>
                                                            {formik.values?.adultPriceChanged ? (
                                                                <div className="d-flex align-items-center mt-3">
                                                                    <NewInputText
                                                                        extraClass="mb-1"
                                                                        name="adultPrice"
                                                                        maxLength={5}
                                                                        onKeyPress={(event) => {
                                                                            if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        inputType="number"
                                                                        disabled={edit}
                                                                        onKeyDown={InputNumberFunc}
                                                                        onFocusOut={formik.handleBlur}
                                                                        onChange={formik.handleChange}
                                                                        value={formik.values.adultPrice}
                                                                        labelText="Enter New Amount"
                                                                        controlClass="newAdult"
                                                                    />
                                                                </div>
                                                            ) : <></>}
                                                        </div>
                                                    </div>
                                                    {!experience?.ageRestriction ? <div>
                                                        <div className="d-flex pr-3 border-left pl-3">
                                                            <div className="enKidsIcon mr-2">
                                                                <Image
                                                                    src={require("../../../../../assets/images/ActionImages/kids.png")}
                                                                    alt="View"
                                                                    title="View"
                                                                    width="6px"
                                                                />
                                                            </div>
                                                            <div className="pl-md-2 enPartyPersonEdit">
                                                                <div className="f14-500 pb-2">Kids</div>
                                                                <div className="d-flex align-items-center">
                                                                    <Button
                                                                        variant="link"
                                                                        className="p-0"
                                                                        disabled={edit}
                                                                        onClick={() => {
                                                                            formik.setFieldValue('kidsCount', formik.values.kidsCount > 0 ? formik.values.kidsCount - 1 : 0)
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                                            alt="Remove"
                                                                            title="Remove"
                                                                            fluid
                                                                        />
                                                                    </Button>
                                                                    <input
                                                                        placeholder="00"
                                                                        className="enInputValueOnly f12-700"
                                                                        value={formik.values.kidsCount}
                                                                        name="kids"
                                                                        id="kids"
                                                                    />
                                                                    <Button
                                                                        variant="link"
                                                                        className="p-0"
                                                                        disabled={edit}
                                                                        onClick={() => {
                                                                            if ((experience?.expType === "CURATED" && formik.values.adultCount + formik.values.kidsCount < experience?.maxSeats && formik.values.adultCount + formik.values.kidsCount < experience?.seatsLeft) || experience?.expType === "SPECIAL")
                                                                                formik.setFieldValue('kidsCount', formik.values.kidsCount + 1)
                                                                            else errorAlert("Reached Maximum limit")
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                                            alt="Add"
                                                                            title="Add"
                                                                            fluid
                                                                        />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-3" style={{ paddingLeft: "6rem" }}>
                                                            <i
                                                                className="fa fa-inr mr-2 pt-1"
                                                                style={{ fontSize: "15px" }}
                                                                aria-hidden="true"
                                                            ></i>
                                                            <p className="f14-500">{experience?.kidsPrice}</p>
                                                            <p className="f10-400 text-gray ml-1">/per person</p>
                                                            <Button
                                                                variant="link"
                                                                className="mr-3"
                                                                disabled={edit}
                                                                onClick={() => {
                                                                    formik.setFieldValue('kidPriceChanged', !formik.values?.kidPriceChanged);
                                                                }}
                                                            >
                                                                <Image
                                                                    src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                                                                    alt="Edit"
                                                                    title="Edit"
                                                                    fluid
                                                                />
                                                            </Button>
                                                            {formik.values?.kidPriceChanged ? (
                                                                <div className="d-flex align-items-center mt-3">
                                                                    <NewInputText
                                                                        extraClass="mb-1"
                                                                        name="kidsPrice"
                                                                        disabled={edit}
                                                                        maxLength={5}
                                                                        onKeyPress={(event) => {
                                                                            if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        inputType="number"
                                                                        onKeyDown={InputNumberFunc}
                                                                        onFocusOut={formik.handleBlur}
                                                                        onChange={formik.handleChange}
                                                                        value={formik.values.kidsPrice}
                                                                        labelText="Enter New Amount"
                                                                        controlClass="newAdult"
                                                                    />
                                                                </div>
                                                            ) : <></>}
                                                        </div>
                                                    </div> : <></>}

                                                </div>
                                                : <></>
                                            }
                                        </>
                                        : <></>}
                                </div>
                            </>)}
                        </div>
                    </Col>
                        <hr />
                    </> : <></>}
                    <Col md={12} lg={8}>
                        {experience?.handicapAccess || experience?.highchairAccess ? (
                            <>
                                <div className="d-flex flex-wrap align-items-center pb-4">
                                    <div className="f16-500">
                                        Need Handicap access or a Highchair?
                                    </div>
                                    <div className="d-flex align-items-center py-4 pl-md-4">
                                        <div className="f16-700 mr-2">No</div>
                                        <Switch
                                            onChange={() => formik.setFieldValue('highchairAccess', !formik.values.highchairAccess)}
                                            checked={formik.values.highchairAccess}
                                            disabled={edit}
                                            offColor="#EEEEEE"
                                            onColor="#EEEEEE"
                                            offHandleColor="#212121"
                                            onHandleColor="#59F832"
                                            handleDiameter={24}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            height={15}
                                            width={41}
                                            boxShadow="-2px 0px 5px #0000003B"
                                            activeBoxShadow="-2px 0px 5px #0000003B"
                                            id="material-switch"
                                        />
                                        <div className="f16-500 ml-2">Yes</div>
                                    </div>
                                </div>
                                {formik.values.highchairAccess ? (
                                    <>
                                        <div className="d-flex enPartySize pb-4">
                                            {experience?.handicapAccess && <div className="d-flex pr-3 pb-3">
                                                <div className="enKidsIcon mr-2">
                                                    <Image
                                                        src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                                                        alt="View"
                                                        title="View"
                                                        className="custom"
                                                    />
                                                </div>
                                                <div className="pl-md-2 enPartyPersonEdit">
                                                    <div className="f14-500 pb-2">Handicap</div>
                                                    <div className="d-flex align-items-center">
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            disabled={edit}
                                                            onClick={() => { formik.setFieldValue('handicapCount', formik.values?.handicapCount > 0 ? formik.values?.handicapCount - 1 : 0) }}
                                                        >
                                                            <Image
                                                                src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                                alt="Remove"
                                                                title="Remove"
                                                                fluid
                                                            />
                                                        </Button>
                                                        <input
                                                            placeholder="00"
                                                            className="enInputValueOnly f12-700"
                                                            value={formik.values.handicapCount}
                                                        />
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            disabled={edit}
                                                            onClick={() => { formik.setFieldValue('handicapCount', formik.values?.handicapCount + 1) }}
                                                        >
                                                            <Image
                                                                src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                                alt="Add"
                                                                title="Add"
                                                                fluid
                                                            />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>}
                                            {experience?.highchairAccess && <div className="d-flex border-left pl-3 pb-3">
                                                <div className="enKidsIcon mr-2">
                                                    <Image
                                                        src={require("../../../../../assets/images/ActionImages/highchair.svg")}
                                                        alt="View"
                                                        title="View"
                                                        className="custom"
                                                    />
                                                </div>
                                                <div className="pl-md-2 enPartyPersonEdit">
                                                    <div className="f14-500 pb-2">Highchair</div>
                                                    <div className="d-flex align-items-center">
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            disabled={edit}
                                                            onClick={() => { formik.setFieldValue('highchairCount', formik.values?.highchairCount > 0 ? formik.values?.highchairCount - 1 : 0) }}
                                                        >
                                                            <Image
                                                                src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                                                alt="Remove"
                                                                title="Remove"
                                                                fluid
                                                            />
                                                        </Button>
                                                        <input
                                                            placeholder="00"
                                                            className="enInputValueOnly f12-700"
                                                            value={formik.values.highchairCount}
                                                        />
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            disabled={edit}
                                                            onClick={() => { formik.setFieldValue('highchairCount', formik.values?.highchairCount + 1) }}
                                                        >
                                                            <Image
                                                                src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                                                alt="Add"
                                                                title="Add"
                                                                fluid
                                                            />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </>
                                ) : null}
                            </>
                        ) : null}
                    </Col>

                    <Col md={12} lg={8} className="pl-0">
                        <div className="col-12">
                            <div className='row'>
                                {experience?.timings?.days.length > 1 ? <div className='col-md-3 col-12'>
                                    <div className='f16-700 mb-4'>Reservation Date</div>
                                    <TextField
                                        id="reservationDate"
                                        label="Reservation Date"
                                        placeholder="DD-MM-YYYY"
                                        variant="outlined"
                                        InputProps={{
                                            inputProps: {
                                                min: moment().diff(experience?.startDate, 'days') > 0 ? moment().format("YYYY-MM-DD") : experience?.sameDayBooking ? moment(experience?.startDate).format("YYYY-MM-DD") : moment(experience?.startDate).add("days", 1).format("YYYY-MM-DD"),
                                                max: moment(experience?.endDate).format("YYYY-MM-DD")
                                            },
                                        }}
                                        type="date"
                                        className={`w-100 ${formik?.errors.reservationDate &&
                                            formik.touched.reservationDate
                                            ? "enError"
                                            : ""
                                            }`}
                                        min={experience?.sameDayBooking ? moment(experience?.startDate).format("YYYY-MM-DD") : moment(experience?.startDate).add("days", 1).format("YYYY-MM-DD")}
                                        max={moment(experience?.endDate).format("YYYY-MM-DD")}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        name="reservationDate"
                                        onChange={(e) => {
                                            if(validateOpen(e.target.value)) formik.handleChange(e)
                                            else errorAlert("Reservation not allowed on this date.");
                                        }}
                                        value={formik.values?.reservationDate}
                                        onBlur={formik.handleBlur}
                                        
                                    />
                                    {formik?.errors.reservationDate &&
                                        formik.touched.reservationDate ? (
                                        <div className="pho_14_regular text-danger">
                                            {formik?.errors.reservationDate}
                                        </div>
                                    ) : null}
                                </div> : <></>}
                                {experience?.expType === 'SPECIAL' ? <div className='col-md-4 col-12 mobile-mt-2'>
                                    <div className='f16-700 mb-4'>Reservation Time Slot</div>
                                    <FormControl variant="outlined" className='w-100'>
                                        <InputLabel htmlFor="outlined-time">
                                            Reservation Time Slot
                                        </InputLabel>
                                        <Select
                                            value={formik.values.reservationTime}
                                            onChange={formik.handleChange}
                                            label="Reservation Time Slot"
                                            placeholder="HH:MM:SS"
                                            inputProps={{
                                                name: "reservationTime",
                                                id: "outlined-time",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                            className='w-100'
                                        >
                                            <MenuItem
                                                value=""
                                                disabled
                                            >
                                                Select Restaurant Time
                                            </MenuItem>
                                            {reservationSlots &&
                                                reservationSlots.map((time, index) => (
                                                    <MenuItem key={index} value={time}>
                                                        {time}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                        {formik?.errors.reservationTime &&
                                            formik?.touched.reservationTime ? (
                                            <div className="pho_14_regular text-danger">
                                                {formik?.errors.reservationTime}
                                            </div>
                                        ) : null}
                                    </FormControl>
                                </div> : <></>}
                            </div>
                        </div>
                        {experience?.expType === 'SPECIAL' ?
                            <div className=''>
                                <div className="col-md-3 col-12 mt-3">
                                    <TextField
                                        id="table"
                                        label="Table No"
                                        variant="outlined"
                                        disabled={edit}
                                        type="text"
                                        className={`w-100 ${formik?.errors.tableNo &&
                                            formik.touched.tableNo
                                            ? "enError"
                                            : ""
                                            }`}
                                        name="tableNo"
                                        onChange={formik.handleChange}
                                        value={formik?.values?.tableNo}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik?.errors.tableNo &&
                                        formik.touched.tableNo ? (
                                        <div className="pho_14_regular text-danger">
                                            {formik?.errors.tableNo}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            : <></>
                        }
                    </Col>
                    {experience?.expType === 'SPECIAL' ?
                        <>
                            <hr />
                            <Col md={12} lg={8}>
                                <Row>
                                    <Col md={12}>
                                        <div className="f16-500 pb-1 pt-3">Seating Preference</div>
                                        <div className="f12-400 pb-3">
                                            Seating is a subject to availability. Your Preference will
                                            be considered.
                                        </div>
                                    </Col>
                                </Row>
                                <Form.Row>
                                    {seatingArea.map((item, index) => (
                                        <div className="col-6 col-md-4" key={index}>
                                            <ReusableOnboardingMapButton
                                             disabled={edit}
                                                key={index}
                                                classsection={
                                                    formik.values.seatingPreference ===
                                                        item.title
                                                        ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                                                        : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                                                }
                                                src={item.icon}
                                                title={item.title}
                                                onClick={() => { formik.setFieldValue('seatingPreference', item.title) }}
                                            />
                                        </div>
                                    ))}
                                </Form.Row>
                            </Col>
                        </>
                        : <></>
                    }
                    <hr />
                    <Col md={12} lg={8} xs={12}>
                        <Form.Group>
                            <TextField
                                id="specialOccasion"
                                label="Special Occasion"
                                type="text"
                                multiline
                                // helperText="* Max 500 Characters"
                                rows="5"
                                variant="outlined"
                                disabled={edit}
                                className={`w-100 mt-3`}
                                name="occasion"
                                onChange={formik.handleChange}
                                value={formik.values.occasion}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12} lg={8} xs={12}>
                        <div className="d-flex align-items-center pt-4">
                            <Button
                                variant="outline-secondary"
                                className="btn150px btn-lg mr-4 px-5"
                                onClick={() => onCancel()}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                className="btn150px btn-lg px-5 mr-3"
                                onClick={() => paymentPage()}
                                disabled={btnDisabled}
                                type="button"
                                title={"Add"}
                            >
                                {type === "EDIT" ? "Save" : "Add"}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
            </div>
        </>
    )
}

export default GuestForm;